(() => {
  const TEST_ID = 'MC_PDP_STICKYBAR_KLEONE';
  const REVIEW_THEME = 'ab/MC_PDP_STICKYBAR_KLEONE';
  const params = new URLSearchParams(window.location.search);
  const arm = params.get('maison_ab_arm');
  if (
    window.Shopify?.theme?.role === 'unpublished' &&
    window.Shopify.theme.name === REVIEW_THEME &&
    params.get('maison_ab_preview') === TEST_ID &&
    (arm === 'control' || arm === 'variation')
  ) {
    document.documentElement.dataset.maisonStickyArm = arm;
  }

  if (customElements.get('kleone-pack-chooser')) return;

  class KleonePackChooser extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.hero = document.querySelector('[data-maison-pdp-hero]');
      this.productForm = this.hero?.querySelector('product-form-component');
      this.form = this.hero?.querySelector('form[action*="/cart/add"]');
      this.originalButton = this.form?.querySelector('button[type="submit"]');
      this.dialog = this.querySelector('.kp-chooser__dialog');
      this.status = this.querySelector('[data-chooser-status]');
      if (!this.form || !this.originalButton || !this.productForm) return;

      this.findBundle = () => {
        const bundle = document.querySelector('[data-maison-pdp-hero] product-form-component kaching-bundle') || this.querySelector('kaching-bundle');
        if (bundle === this.bundle) return;
        this.bundleObserver?.disconnect();
        this.bundle = bundle;
        if (bundle) {
          this.bundleObserver = new MutationObserver(this.sync);
          this.bundleObserver.observe(bundle, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });
        }
      };

      this.sync = () => {
        this.form = document.querySelector('[data-maison-pdp-hero] form[action*="/cart/add"]');
        this.originalButton = this.form?.querySelector('button[type="submit"]');
        this.findBundle();
        const selected = this.bundle?.querySelector('.kaching-bundles__bar--selected');
        const title = selected?.querySelector('.kaching-bundles__bar-title')?.textContent.trim();
        const offerPrice = selected?.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
        const fallbackPrice = document.querySelector('.kp-sticky [data-kp-price]')?.textContent.trim();
        const price = (offerPrice || fallbackPrice || '').replace(/\.00(?=\D|$)/, '');
        const selection = this.querySelector('[data-chooser-selection]');
        if (selection && selection.textContent !== (title || 'Choose your pack')) selection.textContent = title || 'Choose your pack';
        this.querySelectorAll('[data-chooser-add]').forEach((button) => {
          if (!this.busy) {
            button.disabled = !this.originalButton || this.originalButton.disabled || !selected;
            const label = button.disabled ? 'UNAVAILABLE' : `ADD TO CART${price ? ` - ${price}` : ''}`;
            if (button.textContent !== label) button.textContent = label;
          }
        });
        this.querySelector('[data-chooser-open]').disabled = !this.bundle?.querySelector('.kaching-bundles__bars');
      };

      this.mountObserver = new MutationObserver(this.sync);
      this.mountObserver.observe(this.productForm, { childList: true });
      this.buttonObserver = new MutationObserver(this.sync);
      this.buttonObserver.observe(this.originalButton, { attributes: true, attributeFilter: ['disabled'] });
      this.hero.addEventListener('change', this.sync, { signal });
      this.hero.addEventListener('input', this.sync, { signal });
      this.sync();

      this.updateVisibility = () => {
        const button = document.querySelector('[data-maison-pdp-hero] form button[type="submit"]');
        const visible = !!button && button.getBoundingClientRect().bottom <= 0;
        this.dataset.visible = String(visible);
        if (document.documentElement.dataset.maisonStickyArm !== 'variation') {
          const control = document.querySelector('.kp-sticky');
          if (control) control.hidden = !visible;
        }
      };
      window.addEventListener('scroll', this.updateVisibility, { passive: true, signal });
      window.addEventListener('resize', this.updateVisibility, { signal });
      this.updateVisibility();

      this.querySelector('[data-chooser-open]').addEventListener('click', () => this.open(), { signal });
      this.querySelector('[data-chooser-close]').addEventListener('click', () => this.close(), { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      }, { signal });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.dialog.removeAttribute('data-closing');
        this.restoreOffer();
        const afterClose = this.afterClose;
        this.afterClose = null;
        afterClose?.();
      }, { signal });
      this.querySelectorAll('[data-chooser-add]').forEach((button) => button.addEventListener('click', () => this.add(), { signal }));

      document.addEventListener('cart:update', (event) => {
        if (!this.busy) return;
        this.finishAdd(event.detail?.data?.didError ? 'Unable to add to cart. Please try again.' : 'Added to cart');
      }, { signal });
      document.addEventListener('cart:error', (event) => {
        if (this.busy) this.finishAdd(event.detail?.description || event.detail?.message || 'Unable to add to cart. Please try again.');
      }, { signal });
    }

    open() {
      this.sync();
      if (this.dialog.open || !this.bundle?.querySelector('.kaching-bundles__bars')) return;
      this.placeholder = document.createComment('Kaching bundle app');
      this.bundle.before(this.placeholder);
      this.querySelector('[data-chooser-offers]').append(this.bundle);
      this.dialog.showModal();
      this.querySelector('[data-chooser-close]').focus();
    }

    close(afterClose) {
      if (!this.dialog.open || this.dialog.hasAttribute('data-closing')) return;
      this.afterClose = afterClose;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.dialog.close();
        return;
      }
      this.dialog.setAttribute('data-closing', '');
      this.closeTimer = setTimeout(() => this.dialog.close(), 250);
    }

    restoreOffer() {
      if (!this.placeholder) return;
      this.placeholder.replaceWith(this.bundle);
      this.placeholder = null;
      this.sync();
    }

    add() {
      this.sync();
      if (this.busy || this.originalButton.disabled || !this.bundle?.querySelector('.kaching-bundles__bar--selected') || !this.form.reportValidity()) return;
      this.busy = true;
      this.status.textContent = '';
      this.querySelectorAll('[data-chooser-add]').forEach((button) => {
        button.disabled = true;
        button.textContent = 'ADDING…';
      });
      if (this.dialog.open) this.close(() => this.submitAdd());
      else this.submitAdd();
    }

    submitAdd() {
      this.sync();
      this.originalButton?.click();
      this.timeout = setTimeout(() => this.finishAdd('Please check your cart before trying again.'), 15000);
    }

    finishAdd(message) {
      clearTimeout(this.timeout);
      this.busy = false;
      this.status.textContent = message;
      clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => { this.status.textContent = ''; }, 4000);
      this.sync();
    }

    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.afterClose = null;
      if (this.dialog?.open) this.dialog.close();
      this.restoreOffer();
      this.abort?.abort();
      this.mountObserver?.disconnect();
      this.bundleObserver?.disconnect();
      this.buttonObserver?.disconnect();
      clearTimeout(this.timeout);
      clearTimeout(this.statusTimer);
    }
  }

  customElements.define('kleone-pack-chooser', KleonePackChooser);
})();
